(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafraplanDetailController', ManutencaosafraplanDetailController);

    ManutencaosafraplanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Manutencaosafraplan', 'Safra', 'Etapa', 'Atividade'];

    function ManutencaosafraplanDetailController($scope, $rootScope, $stateParams, previousState, entity, Manutencaosafraplan, Safra, Etapa, Atividade) {
        var vm = this;

        vm.manutencaosafraplan = entity;
        vm.previousState = previousState.name;

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.manutencaosafraplan.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:manutencaosafraplanUpdate', function(event, result) {
            vm.manutencaosafraplan = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
